import { Paper, Grid, Card, CardHeader, CardContent, Button, styled } from "@mui/material";
import { MdAccessTimeFilled, MdBolt, MdTimer } from "react-icons/md";
import { FaChargingStation } from "react-icons/fa"
import { GlobalButton } from "../styled/Button";

interface CardProps {
    energy: number,
    mode: string,
    time: string,
    handleEdit: () => void,
    handleCancel: () => void
}

const StyledButton = styled(Button)({
    borderRadius: '15px',
    border: '2.5px solid #77c768',
    color: '#77c768',
    fontWeight: 'bolder',
    textTransform: 'none',

})

export default function SummaryCard({energy, mode, time, handleEdit, handleCancel} : CardProps) {

    return(
        <Card elevation={0} sx={
            {
                backgroundColor: 'rgba(119, 199, 104, 0.20)',
                marginTop: '1rem',
                borderRadius: '15px',
                padding: '8',
                fontSize: '1.1rem'
            }
        }>
            <CardContent>
                <p style={{fontWeight: 900}}><u>Current Session</u></p>
                <Grid container     
                direction={'row'} 
                marginTop={'1rem'} 
                justifyContent='space-around'
                >
                    <Grid item>
                        <MdBolt size={30} /><b style={{color: '#77c768'}}>{energy} kWh</b>
                    </Grid>
                    <Grid item>
                        <FaChargingStation size={30} /> <b style={{ color: '#77c768'}}>{mode}</b>
                    </Grid>
                    <Grid item>
                        <MdAccessTimeFilled size={30} /> <b style={{ color: '#77c768' }}>{time}</b>
                    </Grid>
                </Grid>
                <Grid container 
                marginTop={'1rem'}  
                alignItems="center"
                columnSpacing={2}
                justifyContent="space-between">
                    <Grid item xs={6}>
                        <StyledButton 
                        variant="outlined" 
                        color="success"
                        onClick={handleEdit} fullWidth>Edit</StyledButton>
                    </Grid>
                    <Grid item xs={6}>
                       <GlobalButton text="Cancel" onClick={handleCancel}></GlobalButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
            
    )

}